module.exports = __webpack_public_path__ + "img/icon_map_1_5_hg.337d52b1.png";